import { SitemapCheckboxControl } from './checkbox';

const { PanelBody, PanelRow, TextControl } = wp.components;
const { __ } = wp.i18n;

/**
 * Shared bounded linked-pagination controls for dynamic sitemap blocks.
 *
 * @param {Object}   root0               Component properties.
 * @param {string}   root0.id            Stable sitemap ID.
 * @param {string}   root0.idPrefix      Prefix used when creating an ID.
 * @param {boolean}  root0.paginate      Whether pagination is enabled.
 * @param {number}   root0.pageSize      Entries displayed on one page.
 * @param {Function} root0.setAttributes Block attribute updater.
 * @param {string}   root0.help          Context-specific help text.
 * @param {string}   root0.entriesLabel  Page-size control label.
 * @return {Element} Pagination settings panel.
 */
export function LinkedPaginationPanel({
	id,
	idPrefix,
	paginate,
	pageSize,
	setAttributes,
	help,
	entriesLabel,
}) {
	const updatePagination = (isChecked) => {
		const paginationAttributes = { paginate: isChecked };
		if (isChecked && !id) {
			paginationAttributes.id = `${idPrefix}-${Date.now().toString(36)}`;
		}
		setAttributes(paginationAttributes);
	};

	return (
		<PanelBody
			title={__('Pagination', 'simple-sitemap')}
			initialOpen={false}
		>
			<PanelRow className="simple-sitemap general-chk">
				<SitemapCheckboxControl
					value={paginate}
					label={__('Enable linked pagination', 'simple-sitemap')}
					help={help}
					updateCheckbox={updatePagination}
				/>
			</PanelRow>
			{paginate && (
				<PanelRow className="simple-sitemap">
					<TextControl
						type="number"
						label={entriesLabel}
						min="1"
						max="200"
						value={pageSize}
						onChange={(value) => {
							setAttributes({
								page_size: Math.min(
									200,
									Math.max(
										1,
										Number.parseInt(value, 10) || 50
									)
								),
							});
						}}
					/>
				</PanelRow>
			)}
		</PanelBody>
	);
}
